<p-toast></p-toast>
<p-toolbar>
  <ng-template pTemplate="left">
    <button pButton pRipple label="Новий запис" icon="pi pi-plus" class="p-button-success mr-2" [disabled]="editMode" (click)="addBankCredential()"></button>
  </ng-template>
  <ng-template pTemplate="right">
    <p-button icon="pi pi-refresh" label="Оновити" (onClick)="reloadTable()" [disabled]="editMode"
              pTooltip="Оновити список" tooltipPosition="top"></p-button>
  </ng-template>
</p-toolbar>

<p-table #ABC1 [value]="bankCredentials"
         [rowHover]="true"
         [resizableColumns]="true"
         editMode="row"
         dataKey="uid"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
  <ng-template pTemplate="header">
    <tr>
      <th style="width:6rem"></th>
      <th width="24%">Компанія</th>
      <th width="16%">Банк</th>
      <th width="22%">Credential key</th>
      <th width="18%">IBAN</th>
      <th width="14%">Створено</th>
      <th style="width:4rem"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="row">
      <td>
        <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(row)" class="p-button-rounded p-button-text"></button>
        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(row)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(row, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
      </td>
      <td style="overflow: visible !important">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <app-companyselector [parentCompany]="mainCompanyId" [selectedID]="row.cliid" [showLabel]="false"
                                 [showEditButton]="false" [showAddButton]="false" [showSearchButton]="false"
                                 placeholder="Обрати компанію..." (selectedCompanyID)="row.cliid = $event" [style]="{'width':'100%'}"></app-companyselector>
          </ng-template>
          <ng-template pTemplate="output">
            {{cliName(row.cliid)}}
            <button *ngIf="row.cliid" pButton pRipple type="button" icon="pi pi-external-link"
                    (click)="onOpenClient(row)" class="p-button-rounded p-button-text p-button-sm ml-1"
                    pTooltip="Відкрити компанію в новій вкладці" tooltipPosition="top"></button>
          </ng-template>
        </p-cellEditor>
      </td>
      <td class="overflow-visible">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-dropdown [options]="bankOptions" [(ngModel)]="row.bank_name" optionLabel="label" optionValue="value" placeholder="Обрати банк..." [style]="{'width':'100%'}"></p-dropdown>
          </ng-template>
          <ng-template pTemplate="output">{{row.bank_name}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="row.credential_key" style="width:100%"></ng-template>
          <ng-template pTemplate="output">{{row.credential_key}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="row.iban" style="width:100%"></ng-template>
          <ng-template pTemplate="output">{{row.iban}}</ng-template>
        </p-cellEditor>
      </td>
      <td>{{row.created_at | date:'dd.MM.yyyy'}}</td>
      <td>
        <button *ngIf="!editing" pButton pRipple type="button" icon="pi pi-trash" [disabled]="editMode" (click)="deleteBankCredential(row)" class="p-button-rounded p-button-text p-button-danger"></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr><td colspan="7">Немає банківських облікових даних</td></tr>
  </ng-template>
</p-table>
